<!-- @format -->

<skillsheet>
  <career-years
    if="{ state.master.career_years }"
    master="{ state.master.career_years }"
    data="{ state.data.career_years }"
    on-update="{ onUpdateCareerYears }"
  ></career-years>

  <skills
    if="{ state.master.skills }"
    master="{ state.master.skills }"
    data="{ state.data.skills }"
    errors="{ state.errors.skills }"
    on-update="{ onUpdateSkills }"
  ></skills>

  <genres
    if="{ state.master.genres }"
    master="{ state.master.genres }"
    data="{ state.data.genres }"
    errors="{ state.errors.genres }"
    on-update="{ onUpdateGenres }"
  ></genres>

  <sports
    if="{ state.data.sports }"
    data="{ state.data.sports }"
    on-update="{ onUpdateSports }"
  ></sports>

  <div class="box_flex03 margin-spacing-2_top">
    <div
      class="button button-secondary-large"
      type="button"
      value="登録する"
      onclick="{ onSubmit }"
    >
      登録する
    </div>
  </div>

  <script>
    import di from "dependeny-injection";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";
    import modal from "@tags/modal/search-modal.riot";
    import careerYears from "./skillsheet/career-years.riot";
    import skills from "./skillsheet/skills.riot";
    import genres from "./skillsheet/genres.riot";
    import sports from "./skillsheet/sports.riot";
    import {
      MediaStore,
      ContentsStore,
      SkillStore,
      GenresStore,
    } from "@model/skillsheet/skillsheet.js";

    export default {
      components: {
        "search-modal": modal,
        "career-years": careerYears,
        skills,
        genres,
        sports,
      },
      state: {
        master: {},
        data: {},
        errors: {},
        isRegistered: false,
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
      },
      async onMounted(state, props) {
        const res = await this.PublicInfoApi.request("skillsheet", "fetch");
        this.update({
          master: {
            career_years: res.career_years.master,
            skills: res.skills.master,
            genres: res.genres.master,
          },
          data: {
            career_years: res.career_years.data.reduce((a, c) => {
              a[c.career_type_master_id] = c.year;
              return a;
            }, {}),
            skills: {
              media: new MediaStore(res.skills.data.media),
              contents: new ContentsStore(res.skills.data.contents),
              skill: new SkillStore(res.skills.data.skill),
            },
            genres: new GenresStore(res.genres.data),
            sports: res.sports.data,
          },
        });
        this.update({ isRegistered: this.hasData(this.state) });
      },
      hasData(state) {
        return (
          !!Object.values(state.data.career_years).find((e) => e != 0) ||
          state.data.skills.media.isCheckedGroup() ||
          state.data.skills.contents.isCheckedGroup() ||
          state.data.skills.skill.isCheckedGroup() ||
          state.data.genres.isCheckedGroup() ||
          state.data.sports.hobby != "" ||
          state.data.sports.sports != ""
        );
      },
      onUpdateCareerYears(data) {
        this.state.data.career_years = data;
        this.update({ data: this.state.data });
      },
      onUpdateSkills(data) {
        this.state.data.skills = data;
        this.update({ data: this.state.data });
      },
      onUpdateGenres(data) {
        this.state.data.genres = data;
        this.update({ data: this.state.data });
      },
      onUpdateSports(data) {
        this.state.data.sports = data;
        this.update({ data: this.state.data });
      },

      async onSubmit() {
        this.update({ errors: {} });

        const genres = { ...this.state.data.genres.getPostData() };
        const skills = {
          ...this.state.data.skills.media.getPostData(
            this.state.master.skills.media
          ),
          ...this.state.data.skills.contents.getPostData(
            this.state.master.skills.contents
          ),
          ...this.state.data.skills.skill.getPostData(
            this.state.master.skills.skill
          ),
        };
        const sports = {
          sports: this.state.data.sports.sports,
          hobby: this.state.data.sports.hobby,
        };

        const err = {};
        err["skills"] = this.checkMemoInput(
          ["contents", "media", "skill"],
          skills
        );
        err["genres"] =
          genres.genres.includes("42") && !genres.genre_memo_other
            ? { 42: "入力してください" }
            : false;

        if (err.skills || err.genres) {
          this.error(err);
          return;
        }
        try {
          const res = await this.PublicInfoApi.request(
            "skillsheet",
            "register",
            {
              career_years: JSON.stringify({
                ...Object.entries(this.state.data.career_years).reduce(
                  (a, [id, item]) => {
                    a[`career_year_${id}`] = item;
                    return a;
                  },
                  {}
                ),
              }),
              skills: JSON.stringify(skills),
              genres: JSON.stringify(genres),
              sports: JSON.stringify(sports),
            }
          );
          di.toast.push("スキルシートを更新しました", "success");
          // 新規登録イベント
          if (!this.state.isRegistered && this.hasData(this.state)) {
            this.update({ isRegistered: true });
            window.analytics.event("unlock_achievement", {
              achievement_id: "skillsheet_first_registration",
            });
          }
        } catch (e) {
          if (e.message == "failed") {
            this.error(e.data.errors);
          } else {
            di.toast.push(e, "negative");
          }
        }
      },
      checkMemoInput(properties, item) {
        let errorItems = {},
          haserror = false;
        for (let property of properties) {
          let errors = {};
          for (const [k, v] of Object.entries(item)) {
            if (k.indexOf(property) !== -1 && !v) {
              const err = k.substr(-3, 3).replace("_", "").replace("o", "");
              errors[err] = "入力してください";
              haserror = true;
            }
          }
          if (errors) {
            errorItems[property] = errors;
          }
        }
        return haserror ? errorItems : false;
      },
      error(err) {
        di.toast.push("入力に問題があります", "negative");
        this.update({ errors: err });
        const container = window.document.querySelector(".container_contents");
        let error = this.$("div.error");
        while ((error = error.previousElementSibling)) {
          if (error.classList.contains("checkbox_list")) {
            break;
          }
        }
        const id = error.closest(`.accordion_body`).getAttribute("data-group");
        this.$(`[data-group="${id}"].accordion_heading`).classList.remove(
          "is-hide"
        );
        this.$(`[data-group="${id}"].accordion_body`).style.display = "block";
        const top = error.getBoundingClientRect().y + container.scrollTop;
        container.scrollTo({ top: top - 8, behavior: "smooth" });
      },
    };
  </script>
</skillsheet>
